import { SET_FILE_UPLOAD_STATE } from '../constants/redux_types'

export const setFileUploadState = payload => {
  return {
    type: SET_FILE_UPLOAD_STATE,
    payload: payload
  }
}
